module.exports = "/images/play-f2.svg?15e658a0658153e304a7fd125445d594";